<template>
  <div class="page page__has-bar page__map">
    <div class="page__hd">
      <h3 class="page__title">目的地</h3>
      <p class="page__desc">{{ to }}</p>
    </div>
    <div id="container" class="page__bd"></div>
    <div class="search_result">
      <div class="weui-cells__title">位置解析结果，请选择</div>

      <div class="weui-cells weui-cells_radio">
        <label class="weui-cell weui-cell_active weui-check__label" v-for="(item, index) in searchResult"
          :key="item.address">
          <div class="weui-cell__bd">
            <p>{{ item.address }}</p>
            <p class="list-item-muted">{{ item.title }}</p>
          </div>
          <div class="weui-cell__ft">
            <input type="radio" class="weui-check" name="value" :value="index" v-model="selected" />
            <span class="weui-icon-checked"></span>
          </div>
        </label>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="startNavigation">开始导航</a>
    </div>
  </div>
</template>
<script>
const appKey = process.env.VUE_APP_BAIDU_LBS_KEY;

export default {
  data() {
    return {
      from: null,
      to: null,
      toPoint: null,
      toLocation: null,
      searchResult: [],
      selected: null
    }
  },
  mounted() {
    window.BMAP_PROTOCOL = "https";
    window.BMapGL_loadScriptTime = new Date().getTime();
    this.loadCss();
    this.loadScript();
  },
  watch: {
    selected(value) {
      let me = this, item = me.searchResult[value];
      if (item) {
        me.toPoint = item.point;
        me.map.centerAndZoom(item.point, 16);
        me.map.clearOverlays();
        me.map.addOverlay(
          new window.BMapGL.Marker(item.point, { title: item.title })
        );
        var myGeo = new window.BMapGL.Geocoder();
        myGeo.getLocation(item.point, function (rs) {
          me.toLocation = rs.addressComponents;
        });
      } else {
        me.toPoint = null;
        me.toLocation = null;
      }
    }
  },
  methods: {
    loadCss() {
      const link = document.createElement("link");
      link.href = "https://api.map.baidu.com/res/webgl/10/bmap.css";
      link.rel = "stylesheet";
      link.type = "text/css";
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    loadScript() {
      const me = this;
      const script = document.createElement("script");
      const time = this.dateFormat(new Date(), "yyyyMMddhhmmss");
      script.src =
        "https://api.map.baidu.com/getscript?type=webgl&v=3.0&ak=" +
        appKey +
        "&services=&t=" +
        time;
      script.type = "text/javascript";
      script.onload = function () {
        me.showMap();
      };
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    showMap() {
      var me = this,
        keywords = me.$route.query.keywords;
      if (keywords) {
        me.to = keywords;
        me.selected = null;
        var map = new window.BMapGL.Map("container");
        me.map = map;
        map.centerAndZoom(
          new window.BMapGL.Point(114.12862032872661, 22.63125958086781),
          12
        );
        map.enableScrollWheelZoom(true);

        var options = {
          onSearchComplete: function (result) {
            // 判断状态是否正确
            if (local.getStatus() == window.BMAP_STATUS_SUCCESS) {
              me.searchResult = result._pois;
              me.selected = 0;
            } else {
              me.$weui.alert("无法搜索到结果！");
            }
          }
        };
        var local = new window.BMapGL.LocalSearch(map, options);
        local.search(keywords);
      }
    },
    startNavigation() {
      var me = this;
      if (!me.toPoint || !me.toLocation) {
        window.location.href = `https://api.map.baidu.com/geocoder?address=${me.to}&output=html&src=webapp.usoftchina.saas`;
        return;
      }
      var geo = new window.BMapGL.Geolocation();
      geo.getCurrentPosition(function (r) {
        if (r && r.point) {
          var myGeo = new window.BMapGL.Geocoder();
          myGeo.getLocation(r.point, function (rs) {
            var fromLocation = rs.addressComponents;
            window.location.href = `https://api.map.baidu.com/direction?origin=latlng:${r.point.lat},${r.point.lng}|name:我的位置&origin_region=${fromLocation.city}&destination=latlng:${me.toPoint.lat},${me.toPoint.lng}|name=${me.to}&destination_region=${me.toLocation.city}&mode=driving&output=html&src=webapp.usoftchina.saas`;
          });
        } else {
          window.location.href = `https://api.map.baidu.com/geocoder?address=${me.to}&output=html&src=webapp.usoftchina.saas`;
        }
      });
    }
  },
};
</script>

<style>
.page__map {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page__map .page__hd {
  padding: 10px;
}

.page__map .page__bd {
  flex: 1;
  overflow: hidden;
}

.page__map .search_result .weui-cells {
  height: 300px;
  overflow-y: auto;
  margin-bottom: 50px;
}
</style>